import { apiFetch } from "../../shared/helper/apiFetch";
import history from "../../shared/utils/history";

const basePath = "/api";

// -------------------- Login --------------------
function login(code) {
  const headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    ...(code && { "signin-token": code }),
  };

  const requestOptions = {
    method: "GET",
    headers,
  };

  const url = `${basePath}/auth/login`;

  return apiFetch(url, requestOptions)
    .then((data) => {
      console.log("Login response data:", data);
      return data;
    })
    .catch((error) => {
      console.error("Login error:", error);
      return Promise.reject(error);
    });
}

// -------------------- Logout --------------------
function logout() {
  localStorage.removeItem("user");
  history.push("/");
  window.onbeforeunload = null;
  window.location.reload();
}

// -------------------- Export --------------------
const loginServices = {
  login,
  logout,
};

export default loginServices;
